module.exports = __webpack_public_path__ + "static/fanband-hand-83a3dfc48c4d51cb843485df4cd888be.png";